import { userSaga, notificationsSaga } from '@prometheus/redux';
import { all, spawn } from 'redux-saga/effects';

const rootSaga = function* () {
  yield all([spawn(userSaga), spawn(notificationsSaga)]);
};

export default rootSaga;
